import Http from '../http'
// 出租车模块API
export default {
  // 车辆营收排行
  getRevenueRanking (params) {
    return Http.post('/taxi/getRevenueRanking.do', params)
  },
  // 车辆营收排行-导出
  exportRevenueRanking() {
    return '/taxiExport/getRevenueRanking.do'
  },
  // 车辆营运里程排行
  getRevenueMileage (params) {
    return Http.post('/taxi/getRevenueMileage.do', params)
  },
  // 车辆营运里程排行-导出
  exportRevenueMileage() {
    return '/taxiExport/getRevenueMileage.do'
  },
  // 车辆营运里程利用率排行
  getMileageUtilization (params) {
    return Http.post('/taxi/getMileageUtilization.do', params)
  },
  // 车辆营运里程利用率排行-导出
  exportMileageUtilization () {
    return '/taxiExport/getMileageUtilization.do'
  },
  // 车辆营运客单价排行
  getRevenueForPrice (params) {
    return Http.post('/taxi/getRevenueForPrice.do', params)
  },
  // 车辆营运客单价排行-导出
  exportRevenueForPrice () {
    return '/taxiExport/getRevenueForPrice.do'
  },
  // 车辆营运数量
  getRevenueCount (params) {
    return Http.post('/taxi/getRevenueCount.do', params)
  },
  // 企业运营日报
  getRevenueByDay (params) {
    return Http.post('/taxi/getRevenueByDay.do', params)
  },
  // 企业运营日报-导出
  exportRevenueByDay () {
    return '/taxiExport/getRevenueByDay.do'
  },
  // 营收情况
  sourceOfDistribution (params) {
    return Http.post('/taxi/sourceOfDistribution.do', params)
  },
  // 企业运营月报
  getRevenueByMonth (params) {
    return Http.post('/taxi/getRevenueByMonth.do', params)
  },
  // 企业运营月报-导出
  exportRevenueByMonth () {
    return '/taxiExport/getRevenueByMonth.do'
  },
  // 企业运营年报
  getRevenueByYear (params) {
    return Http.post('/taxi/getRevenueByYear.do', params)
  },
  // 企业运营年报-导出
  exportRevenueByYear () {
    return '/taxiExport/getRevenueByYear.do'
  },
  // 营收来源，运距及支付方式
  sourceOfRevenue (params) {
    return Http.post('/taxi/sourceOfRevenue.do', params)
  },
  // 营收来源，运距及支付方式-导出
  exportSourceOfRevenue () {
    return '/taxiExport/sourceOfRevenue.do'
  },
  // 服务评价月报表
  getEvaluateByMonth (params) {
    return Http.post('/taxiService/getEvaluateByMonth.do', params)
  },
  // 服务评价月报表-导出
  exportEvaluateByMonth () {
    return '/taxiExport/getEvaluateByMonth.do'
  },
  // 司机服务评价排名
  getDriverRanking (params) {
    return Http.post('taxiService/getDriverRanking.do', params)
  },
  // 司机服务评价排名-导出
  exportDriverRanking () {
    return '/taxiExport/getDriverRanking.do'
  },
  // 服务投诉月报表
  getComplainByMonth (params) {
    return Http.post('taxiService/getComplainByMonth.do', params)
  },
  // 服务投诉月报表-导出
  exportComplainByMonth () {
    return '/taxiExport/getComplainByMonth.do'
  },
  // 司机服务投诉排名
  getDriverComplainRanking (params) {
    return Http.post('taxiService/getDriverComplainRanking.do', params)
  },
  // 司机服务投诉排名-导出
  exportDriverComplainRanking () {
    return '/taxiExport/getDriverComplainRanking.do'
  },
  // 支出汇总
  getSpendSumByYear (params) {
    return Http.post('spend/getSpendSumByYear.do', params)
  },
  // 导出-支出管理-支出汇总(出租车)
  exportSpendSumByYear() {
    return '/taxiExport/getSpendSumByYear.do'
  },
  // 加油充电记录列表
  fuelChargelist (params) {
    return Http.post('fuelCharge/fuelChargelist.do', params)
  },
  // 导出-支出管理-加油充电记录
  exportFuelChargelist() {
    return '/taxiExport/fuelChargelist.do'
  },
  // 添加
  addFuelCharge (params) {
    return Http.post('fuelCharge/addFuelCharge.do', params)
  },
  // get
  getFuelCharge (params) {
    return Http.post('fuelCharge/getFuelCharge.do', params)
  },
  // 编辑
  updateChargingRecord (params) {
    return Http.post('fuelCharge/updateChargingRecord.do', params)
  },
  // 删除
  deleteChargingRecord (params) {
    return Http.post('fuelCharge/deleteChargingRecord.do', params)
  },
  // 维修保养记录列表
  maintenancelist (params) {
    return Http.post('maintenance/maintenancelist.do', params)
  },
  // 导出-支出管理-维修保养记录记录
  exportMaintenance() {
    return '/taxiExport/maintenance.do'
  },
  // get
  getMaintenance (params) {
    return Http.post('maintenance/getMaintenance.do', params)
  },
  // 添加
  addMaintenance (params) {
    return Http.post('maintenance/addMaintenance.do', params)
  },
  // 更新
  updateMaintenance (params) {
    return Http.post('maintenance/updateMaintenance.do', params)
  },
  // 删除
  deleteMaintenance (params) {
    return Http.post('maintenance/deleteMaintenance.do', params)
  },
  // 其他补贴列表
  supplementlist (params) {
    return Http.post('supplement/supplementlist.do', params)
  },
  // 导出-支出管理-其他补贴
  exportSupplement() {
    return '/taxiExport/supplement.do'
  },
  // get
  getSupplement (params) {
    return Http.post('/supplement/getSupplement.do', params)
  },
  // 添加
  addSupplement (params) {
    return Http.post('supplement/addSupplement.do', params)
  },
  // 更新
  updateSupplement (params) {
    return Http.post('supplement/updateSupplement.do', params)
  },
  // 删除
  deleteSupplement (params) {
    return Http.post('supplement/deleteSupplement.do', params)
  },
  // 司机管理及年龄分布
  driverAgeManage (params) {
    return Http.post('driverinfo/getDriverlist.do', params)
  },
  // 导出-其他分析-司机管理及年龄分布
  exportDriverAgeManage() {
    return '/taxiExport/driverAgeManage.do'
  },
  // 车龄及品牌分布
  autoAgeManage (params) {
    return Http.post('vehicle/getVehiAgelist.do', params)
  },
  // 导出-其他分析-车龄及品牌分布
  exportVehiAgelist() {
    return '/taxiExport/vehiAgelist.do'
  },
  // 获取运营时段
  getOperatingTime (params) {
    return Http.post('operatingTime/get.do', params)
  },
  // 添加运营时段
  addOperatingTime (params) {
    return Http.post('operatingTime/add.do', params)
  },
  // 投诉登记-处理
  handleComplaints (params) {
    return Http.post('taxi/handleComplaints.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/taxi.js